import { getPageTitle } from "../../utils/GetPageTitle";
import {
  SUBMIT_USER_ACTIVITY_ACTION_DISPATCHER,
  SUBMIT_USER_ACTIVITY_ACTION_REQUESTED,
  SUBMIT_USER_ACTIVITY_ERROR_DISPATCHER,
  GET_USER_ACTIVITY_ACTION_REQUESTED
} from "./Action";

const initialState = {
  successData: { data:[],topTenExcelData:[],bottomTenExcelData:[]},
  failureData: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_USER_ACTIVITY_ACTION_REQUESTED:
      return { ...state, loading: true };
      case GET_USER_ACTIVITY_ACTION_REQUESTED:
        return { ...state, loading: true };
    case SUBMIT_USER_ACTIVITY_ACTION_DISPATCHER:
      const tempTopTenExcelArr = [["User", "Area","Region","Page Title","Total Time Spent"]];
      const tempBottomTenExcelArr = [["User", "Area","Region","Page Title","Total Time Spent"]];

      let userData = action.payload.data;
      userData?.top10?.forEach((e) => {
        tempTopTenExcelArr.push([
          e.user_name,
          e.area,
          e.region,
          getPageTitle(e.page_url),
          e.total_time_spent
        ])
      })
      userData?.bottom10?.forEach((e) => {
        tempBottomTenExcelArr.push([
          e.user_name,
          e.area,
          e.region,
          getPageTitle(e.page_url),
          e.total_time_spent
        ])
      })

      // console.log("data: ", data);
      return {
        ...state,
        successData: {
          data:userData,
          bottomTenExcelData:tempBottomTenExcelArr,
          topTenExcelData:tempTopTenExcelArr
        },
        loading: false,
      };
    case SUBMIT_USER_ACTIVITY_ERROR_DISPATCHER:
      return {
        ...state,
        failureData: action.payload,
        loading: false,
      };
  
    default:
      return state;
  }
};

export default reducer;
